import { mapGetters } from 'vuex'

function compareWorkTypes (workType1, workType2) {
  return getWorkTypePriority(workType2) - getWorkTypePriority(workType1)
}

// const currentWorkTypesIds = this.request && this.request.workTypes ? new Set(this.request.workTypes.map(workType => workType.id)) : new Set()
function getWorkTypePriority (workType) {
  // if (currentWorkTypesIds.has(workType.id)) {
  //   return 2
  // }
  return workType.notMatch ? 0 : 1
}

export const LABEL_MARKS = {
  workType: '🛠',
  technologicalOperation: '◔',
  workPackage: '{🛠}'
}

export const requestWorkTypes = {
  // data: function () {
  //   return {
  //     // request: null, // Required
  //     // isAudit: null // Required
  //   }
  // },
  computed: {
    ...mapGetters({
      allWorkTypes: 'getWorkTypes'
    }),
    availableWorkTypes: function () {
      let filteredWorkTypes = []
      if (this.request) {
        let workAreasKeys = null
        const workAreas = this.$store.getters.getSelectedWorkAreas
        if (workAreas && workAreas.length) {
          workAreasKeys = workAreas.map(workArea => workArea.key)
        }
        const assigneeWorkAreasKeys = this.request.assigneeWorkAreas && this.request.assigneeWorkAreas.length
          ? this.request.assigneeWorkAreas.map(wa => wa.key)
          : null
        filteredWorkTypes = this.request.filterWorkTypes(this.allWorkTypes, this.isAudit, workAreasKeys)
        if (assigneeWorkAreasKeys && assigneeWorkAreasKeys.length) {
          filteredWorkTypes = filteredWorkTypes.filter(wt => wt.workAreas ? wt.workAreas.some(wa => assigneeWorkAreasKeys.includes(wa)) : true)
        }
      }

      console.log('Available Work Types count: ' + filteredWorkTypes.length)
      filteredWorkTypes.sort(compareWorkTypes)
      return filteredWorkTypes
    }
  }
}
